module.exports = __webpack_public_path__ + "img/navarra-publica-logo.57995789.png";